<!--
 Authors: Rahul Abhishek 
 -->
<router-outlet>
    <app-spinner></app-spinner>
</router-outlet>